import React, { ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import { useUserAuth } from '../context/UserAuthContext';

interface ProtectedRouteProps {
  children: ReactElement;
  requireCompleteInfo?: boolean; // 추가 정보 완료 필수 여부 (기본: true)
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  children, 
  requireCompleteInfo = true 
}) => {
  const { user, isLoggedIn, isInitialized, isAutoLoginInProgress } = useUserAuth();

  // 초기화가 완료되지 않았거나 자동 로그인이 진행 중이면 로딩 표시
  if (!isInitialized || isAutoLoginInProgress) {
    return <div>Loading...</div>;
  }

  // 초기화 완료 후 로그인되지 않았으면 로그인 페이지로 리다이렉트
  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  // 로그인은 되어 있지만 추가 정보가 필요한 경우 추가 정보 입력 페이지로 리다이렉트
  if (requireCompleteInfo && user?.needMoreInfo) {
    return <Navigate to="/additional-info" replace />;
  }

  return children;
};

export default ProtectedRoute;
